"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Different kinds of error which may be encountered during evaluation.
 */
var ErrorKinds;
(function (ErrorKinds) {
    ErrorKinds["MalformedFlag"] = "MALFORMED_FLAG";
    ErrorKinds["UserNotSpecified"] = "USER_NOT_SPECIFIED";
    ErrorKinds["FlagNotFound"] = "FLAG_NOT_FOUND";
    ErrorKinds["ClientNotReady"] = "CLIENT_NOT_READY";
    ErrorKinds["WrongType"] = "WRONG_TYPE";
})(ErrorKinds || (ErrorKinds = {}));
exports.default = ErrorKinds;
//# sourceMappingURL=ErrorKinds.js.map